import { Nullable } from 'primereact/ts-helpers';
import { CSSProperties, FC, ReactElement, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '../../Avatar';
import './module.scss';

export type DisplayValueStyles = {
    fontSize?: string;
};

export type AvatarStyles = {
    size?: string;
};

export type AvatarWithDisplayValueColumnProps = {
    data: {
        userId: number;
        displayValue: string;
        description?: string;
    };
    styles?: {
        // Default 40px
        imageSize?: string | number;

        // Default 14px
        titleFontSize?: string | number;

        // Default 12px
        descriptionFontSize?: string | number;
    };
    link?: Nullable<string>;

    /**
     * @deprecated Use styles field
     */
    avatarStyles?: AvatarStyles;

    /**
     * @deprecated Use styles field
     */
    displayValueStyles?: DisplayValueStyles;
};

export const AvatarWithDisplayValueColumn: FC<
    AvatarWithDisplayValueColumnProps
> = (props: AvatarWithDisplayValueColumnProps): ReactElement => {
    const { data, link, styles = {} } = props;

    const {
        titleFontSize = '14px',
        descriptionFontSize = '12px',
        imageSize = '40px',
    } = styles;

    const titleBlock: ReactElement = useMemo(() => {
        const blockProps = {
            className: 'title-text',
            style: {
                fontSize: titleFontSize,
            } satisfies CSSProperties,
            children: data.displayValue,
        };

        if (link) return <Link to={link} {...blockProps} />;
        return <span {...blockProps} />;
    }, [titleFontSize, data.displayValue, link]);

    return (
        <div
            className={'flex align-items-center'}
            style={{
                width: '100%',
                gap: 10,
            }}
        >
            <Avatar
                userId={data.userId}
                size={imageSize}
                style={{
                    aspectRatio: 1,
                }}
            />
            <div
                className="column-text"
                style={{
                    width: 'calc(100% - 32px)',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'space-between',
                }}
            >
                {titleBlock}
                {props.data.description && (
                    <div
                        className="description"
                        style={{
                            width: '100%',
                            fontSize: descriptionFontSize,
                            color: '#5f717a',
                        }}
                    >
                        {props.data.description}
                    </div>
                )}
            </div>
        </div>
    );
};
